import { lazy, Route } from '@tanstack/router'

import { profileRoute } from '..'

const ReferralLayout = lazy(() => import('../../../pages/profile/referral'))

export type ReferralSearch = {
  referral_id?: string
}

export const referralRoute = new Route({
  getParentRoute: () => profileRoute,
  path: 'referral',
  component: ReferralLayout,
  validateSearch: (search: Record<string, unknown>): ReferralSearch => {
    return search
  },
})
